import api from "./interceptor";
import * as config from "./../config/config";

/**
 * 🔹 Dashboard performance (kpis, factures, camions, clients, axes, classement)
 * params : { camion_id, start_date: "YYYY-MM-DD", end_date: "YYYY-MM-DD" } (tous optionnels)
 */
export async function get_Dashboard(params = {}) {
  try {
    const response = await api.get(config.REACT_APP_ENDPOINT_DASHBOARD, {
      params,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function get_ConsommationCarburant(params) {
  try {
    const response = await api.get(config.REACT_APP_ENDPOINT_CONSOMMATION_CARBURANT, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
}
 
// Renvoie un Blob (fichier .xlsx) — à consommer avec un lien de
// téléchargement généré côté composant.
// export async function export_ConsommationCarburant(params) {
//   try {
//     const response = await api.get(config.REACT_APP_ENDPOINT_CONSOMMATION_CARBURANT_EXPORT, {
//       params,
//       responseType: "blob",
//     });
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// }

export async function export_ConsommationCarburant(params, filename = "consommation_carburant.xlsx") {
  const response = await api.get(config.REACT_APP_ENDPOINT_CONSOMMATION_CARBURANT_EXPORT, {
    params,
    responseType: "blob",
  });

  const blob = new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}